<template>
    <div>
        <h2>Servers</h2>
        <div>
            <div 
            v-for="server in orderedServers" 
            v-bind:class="{ 
                'card': true, 
                'mb-3': true, 
                'card-warning': server.timeout 
            }"
            v-bind:key="server[0].name"
            >

                <div class="card-body" style="background-color:rgba(0,0,0,.03)">

                    <h3>
                        {{ server[0].name }} 
                        <small>
                            <span 
                                v-for="serverApp in server" 
                                class="badge badge-secondary"
                                v-bind:key="serverApp.type"
                            >
                            {{ serverApp.type }}
                            <span v-if="serverApp.handleMoxas"> (M)</span>
                            </span>
                        </small> 
                    </h3>

                    <!-- For most server ip == name, so hide ip if they are the same -->
                    <span v-if="server[0].ip !== server[0].name">
                        <span class="text-muted">Server IP:</span> 
                        <span> {{ server[0].ip }}</span>
                        <br />
                    </span>

        
                </div>


                <ul class="list-group list-group-flush">
                        <li 
                            v-for="serverApp in server" 
                            v-bind:key="serverApp.type"
                            class="list-group-item">

                                <span class="text-muted mr-2">Application:</span> 
                                {{ serverApp.type }} <span v-if="serverApp.handleMoxas"> (M)</span>
                                <br />

                                <span v-if="serverApp.running_for">
                                    <span class="text-muted mr-2">Running for:</span> 
                                    <span> {{ serverApp.running_for | timeSpan }} </span>
                                    <!-- {{ moment(server.started).format("LTS") }} -->
                                    <br />

                                </span>


                                <span v-if="serverApp.statistics.InitliasedDevices">
                                    <span class="badge badge-primary">{{ serverApp.statistics.InitliasedDevices }} initialised devices</span>
                                </span>

                                <span v-if="serverApp.statistics.ConnectedDevices">
                                    <span class="badge badge-warning">{{ serverApp.statistics.ConnectedDevices }} initialising devices</span>
                                </span>
                                
                                <span v-if="serverApp.statistics.Hit"> 
                                    <span class="badge badge-success">{{ serverApp.statistics.Hit }} hits total</span>
                                </span>

                                <span v-if="serverApp.statistics.HitAverage"> 
                                    <span class="badge badge-success">{{ serverApp.statistics.HitAverage }} hit/m</span>
                                </span>


                                <span v-if="serverApp.statistics.ItemsProcessed"> 
                                    <span class="badge badge-success">{{ serverApp.statistics.ItemsProcessed }} items total</span>
                                </span>

                               <span v-if="serverApp.statistics.ItemsProcessedAverage"> 
                                    <span class="badge badge-success">{{ serverApp.statistics.ItemsProcessedAverage }} items/m</span>
                                </span>

                                <span v-if="serverApp.statistics.EventsProcessed"> 
                                    <span class="badge badge-success">{{ serverApp.statistics.EventsProcessed }} events total </span>
                                </span>

                                <span v-if="serverApp.statistics.EventsProcessedAverage"> 
                                    <span class="badge badge-success">{{ serverApp.statistics.EventsProcessedAverage }} events/m</span>
                                </span>
                                

              


                        </li>
                    </ul>



            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import _ from 'underscore'

    export default {
        data() {
            return {
            };
        },
        filters: {
            timeSpan(s) {
                return s.substring(0, s.lastIndexOf('.'));
            }
        },
        props: {
        },
        computed: {
            ...mapState({
                servers: state => state.servers
            }),
            orderedServers() {
                var a = _.chain(this.servers)
                            .sortBy('name')
                            .sortBy('type')
                            .value();  
                var b = _.groupBy(a, 'name');
                return b;
            }
        },
        watch: {
        }
    }
</script>

<style>
</style>
